import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/bo`, withCredentials: true });

let csrfToken = null;

const readCookie = (name) => {
  const prefix = `${encodeURIComponent(name)}=`;
  const item = document.cookie.split("; ").find((part) => part.startsWith(prefix));
  return item ? decodeURIComponent(item.slice(prefix.length)) : null;
};

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (!["get", "head", "options"].includes(method)) {
    const token = csrfToken || readCookie("bo_csrf");
    if (token) config.headers.set("X-CSRF-Token", token);
  }
  return config;
});

let refreshing = null;
let stepUpHandler = null;
export const setStepUpHandler = (fn) => { stepUpHandler = fn; };
api.interceptors.response.use(
  (r) => {
    csrfToken = r.headers?.["x-csrf-token"] || csrfToken;
    return r;
  },
  async (error) => {
    csrfToken = error.response?.headers?.["x-csrf-token"] || csrfToken;
    const cfg = error.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/register"].some((u) => (cfg.url || "").includes(u));
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("bo:logout"));
      }
    }
    if (error.response?.status === 403 && error.response.data?.detail === "Token CSRF inválido ou ausente" && !cfg._csrf) {
      cfg._csrf = true;
      if (!error.response.headers?.["x-csrf-token"]) await api.get("/support").catch(() => {});
      return api(cfg);
    }
    if (error.response?.status === 403 && error.response.data?.detail?.code === "STEP_UP_REQUIRED" && !cfg._stepup && stepUpHandler) {
      cfg._stepup = true;
      if (await stepUpHandler()) return api(cfg);
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Ocorreu um erro. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmt = (v) =>
  `${Number(v || 0).toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} STN`;

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "";

export const STATUS = {
  pending_payment: { label: "Aguarda pagamento", cls: "bg-amber-100 text-amber-800" },
  confirmed: { label: "Confirmada", cls: "bg-emerald-100 text-emerald-800" },
  preparing: { label: "Em preparação", cls: "bg-sky-100 text-sky-800" },
  ready: { label: "Pronta", cls: "bg-indigo-100 text-indigo-800" },
  out_for_delivery: { label: "Em entrega", cls: "bg-violet-100 text-violet-800" },
  delivered: { label: "Entregue", cls: "bg-bo-green text-white" },
  cancelled: { label: "Cancelada", cls: "bg-gray-200 text-gray-600" },
  delivery_failed: { label: "Entrega falhada", cls: "bg-red-100 text-red-700" },
};

export const PAY_STATUS = {
  pending: "Pagamento pendente",
  submitted: "Comprovativo em validação",
  confirmed: "Pagamento confirmado",
  rejected: "Comprovativo rejeitado",
  refund_pending: "Reembolso pendente",
  refunded: "Reembolsado",
};

export const DELIVERY = {
  assigned: "Estafeta atribuído", accepted: "Aceite pelo estafeta", picked_up: "Recolhida pelo estafeta",
  in_transit: "Em transporte", delivered: "Entregue", failed: "Entrega falhada", refused: "Recusada pelo estafeta", cancelled: "Cancelada",
};
export const VEHICLE = { moto: "Moto", carro: "Carro", bicicleta: "Bicicleta", a_pe: "A pé" };

export const FULFILL = { pending: "Por preparar", preparing: "Em preparação", ready: "Pronta" };

export const PAY_METHOD = { transfer: "Transferência bancária", cash_on_delivery: "Pagamento na entrega" };

export const IMAGES = {
  merchant: "https://static.prod-images.emergentagent.com/jobs/53a3c7db-37c5-4529-8302-f1ccd75c60b5/images/1189f9e59aab740072f530ee8a9e533742d5616139baed9e78ce92225392f2cb.jpeg",
  rider: "https://static.prod-images.emergentagent.com/jobs/53a3c7db-37c5-4529-8302-f1ccd75c60b5/images/8144a8198ad3c204f27a71f676191ab73d70e97397ba870126997d8db6780def.jpeg",
  panorama: "https://static.prod-images.emergentagent.com/jobs/53a3c7db-37c5-4529-8302-f1ccd75c60b5/images/85df5d20bcfe6fc7f56f39494ef1467febe4a18e17f8ac2141d24f6fee8ceb02.jpeg",
};
